module.exports = __webpack_public_path__ + "img/img-bebidas-bares.12efdee3.webp";